<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#8f8f8f" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-right-icon lucide-chevron-right">
    <path d="m9 18 6-6-6-6"/>
  </svg>
</template>
<script lang="ts">
import {useScreenSize} from "@/composable/useScreenSize.js";
export default {
  name: 'IconChevronRight',
  setup() {
    const { width, isSmallScreen } = useScreenSize(1024);
    return {
      width,
      isSmallScreen,
    }
  }
}
</script>